import About from "./About"
import CallComp from "./Call"
import Clients from "./Clients"
import Contact from "./Contact"
import OtherServices from "./OtherServices"
import Hero from "./Hero"
import Modules from "./Services"



const HomeMain = () => {
    return(
        <main className="main">
            <Hero />
            {/* <About /> */}
            {/* <Modules /> */}
            <OtherServices />
            {/* <Clients /> */}
            {/* <CallComp /> */}
            {/* <ProductsScroll /> */}
            {/* <Contact /> */}
        </main>
    )
}


export default HomeMain